function removeMaskCpf(cpf: string) {
  return cpf.replace(/[^\d]/g, '')
}

function isHiddenCpf(cpf: string) {
  const regex = /^[A-Z]{3}\.[A-Z]{3}\.\d{3}-[A-Z]{2}$/ // XXX.XXX.999-XX
  return regex.test(cpf)
}

function applyMaskCpf(cpf: string) {
  return cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+$/, '$1')
}

export { removeMaskCpf, isHiddenCpf, applyMaskCpf }
